import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import FootballXAcademy from "./pages/FootballXAcademy";
import SocialMedia from "./pages/SocialMedia";
import Shop from "./pages/Shop";
import FootballXJoeys from "./pages/FootballXJoeys";
import EliteTrialPrep from "./pages/EliteTrialPrep";
import Sponsor2027 from "./pages/Sponsor2027";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/academy" element={<FootballXAcademy />} />
          <Route path="/social" element={<SocialMedia />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/joeys" element={<FootballXJoeys />} />
          <Route path="/elite-trial-prep" element={<EliteTrialPrep />} />
          <Route path="/sponsor" element={<Sponsor2027 />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;